<mat-card appearance="outlined">
  <mat-card-title>
    <span class="edit-screen-card-title" [translate]="'riskIndicators.title'"
      >Risk indicators</span
    >
  </mat-card-title>
  <mat-card-content class="remove-mat-form-field-wrapper">
    <form [formGroup]="riskIndicatorsForm">
      <div layout="column">
        <div flex layout="row" layout-wrap layout-align="space-between center">
          <!-- Company Participation -->
          <mat-form-field
            class="risk-display-field"
            flex-gt-md="50"
            flex-gt-sm="70"
            flex="100"
            floatLabel="always"
          >
            <input
              matInput
              type="text"
              formControlName="companyParticipation"
              readonly
              [class.risk-error]="regdataError"
            />
            <mat-label>{{
              'riskIndicators.companyParticipation' | translate
            }}</mat-label>
          </mat-form-field>

          <!-- Phone Match -->
          <mat-form-field
            class="risk-display-field"
            flex-gt-md="50"
            flex-gt-sm="50"
            flex="100"
            floatLabel="always"
          >
            <input
              matInput
              type="text"
              formControlName="phoneMatch"
              readonly
              [class.risk-error]="regdataError"
            />
            <mat-label>{{ 'riskIndicators.phoneMatch' | translate }}</mat-label>
          </mat-form-field>

          <!-- PEP (direct) -->
          <mat-form-field
            class="risk-display-field"
            flex-gt-md="50"
            flex-gt-sm="50"
            flex="100"
            floatLabel="always"
          >
            <input
              matInput
              type="text"
              formControlName="pep"
              readonly
              [class.risk-match]="pepMatch === true && !pepError"
              [class.risk-nomatch]="pepMatch === false && !pepError"
              [class.risk-error]="pepError"
            />
            <mat-label>{{ 'riskIndicators.pep' | translate }}</mat-label>
          </mat-form-field>

          <!-- Related to PEP -->
          <mat-form-field
            class="risk-display-field"
            flex-gt-md="50"
            flex-gt-sm="50"
            flex="100"
            floatLabel="always"
          >
            <input
              matInput
              type="text"
              formControlName="pepRelated"
              readonly
              [class.risk-match]="relatedPepMatch === true && !pepError"
              [class.risk-nomatch]="relatedPepMatch === false && !pepError"
              [class.risk-error]="pepError"
            />
            <mat-label>{{ 'riskIndicators.pepRelated' | translate }}</mat-label>
          </mat-form-field>

          <!-- Action bar: Инфо → Raw JSON → Refresh → timestamp -->
          <div
            flex="100"
            layout="row"
            layout-align="start center"
            style="margin-top: 4px; margin-bottom: 8px"
          >
            <button
              mat-stroked-button
              color="primary"
              type="button"
              style="min-width: 130px; transform: scale(0.9)"
              (click)="onInfoClick()"
            >
              {{
                (showPepReport
                  ? 'riskIndicators.hideInfo'
                  : 'riskIndicators.info'
                ) | translate
              }}
            </button>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              style="margin-left: 4px; min-width: auto; transform: scale(0.9)"
              (click)="onShowRawJsonClick()"
            >
              {{ 'riskIndicators.showRawJson' | translate }}
            </button>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              style="margin-left: 4px; min-width: auto; transform: scale(0.9)"
              (click)="onRefreshRegdata()"
            >
              {{ 'riskIndicators.refreshRegdata' | translate }}
            </button>
            <span class="last-report-date" style="margin-left: 12px">
              {{ 'riskIndicators.lastReport' | translate }}:
              <ng-container *ngIf="lastReportDate; else noDate">
                {{ lastReportDate | date: 'dd.MM.yyyy HH:mm' }}
              </ng-container>
              <ng-template #noDate>
                <span class="no-data-text">{{
                  'riskIndicators.noData' | translate
                }}</span>
              </ng-template>
            </span>
          </div>

          <!-- PEP Report Expandable Table (shown below the action bar) -->
          <div *ngIf="showPepReport" flex="100" class="pep-report-container">
            <div *ngIf="isLoadingPepReport" class="pep-report-loading">
              <mat-spinner diameter="40"></mat-spinner>
            </div>

            <div
              *ngIf="!isLoadingPepReport && pepReportError"
              class="pep-report-error"
            >
              {{ 'riskIndicators.apisUnavailable' | translate }}
            </div>

            <div
              *ngIf="
                !isLoadingPepReport &&
                !pepReportError &&
                pepReportData.length === 0
              "
              class="pep-report-empty"
            >
              {{ 'riskIndicators.noRecords' | translate }}
            </div>

            <table
              *ngIf="
                !isLoadingPepReport &&
                !pepReportError &&
                pepReportData.length > 0
              "
              mat-table
              [dataSource]="pepReportData"
              class="pep-report-table"
            >
              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'riskIndicators.position' | translate }}
                </th>
                <td mat-cell *matCellDef="let record">
                  {{ record.xmlPosition || '-' }}
                </td>
              </ng-container>

              <!-- Institution Column -->
              <ng-container matColumnDef="institution">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'riskIndicators.institution' | translate }}
                </th>
                <td mat-cell *matCellDef="let record">
                  {{ record.xmlWork || '-' }}
                </td>
              </ng-container>

              <!-- End Date Column -->
              <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'riskIndicators.endDate' | translate }}
                </th>
                <td mat-cell *matCellDef="let record">
                  {{
                    record.toDate ? (record.toDate | date: 'yyyy-MM-dd') : '-'
                  }}
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'riskIndicators.status' | translate }}
                </th>
                <td mat-cell *matCellDef="let record">
                  {{ calculatePepStatus(record.toDate) }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="[
                  'position',
                  'institution',
                  'endDate',
                  'status',
                ]"
              ></tr>
              <tr
                mat-row
                *matRowDef="
                  let row;
                  columns: ['position', 'institution', 'endDate', 'status']
                "
              ></tr>
            </table>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
